import React from 'react';
import PropTypes from 'prop-types';

import { Button, Checkbox, Modal } from 'components/ui';

import * as Styled from './DeleteListItemConfirmationModal.styles';

export const DeleteListItemConfirmationModal = ({ onClose, 
  onConfirm, isSaving, 
  title="Usunąć fakturę?", cancelText="Anuluj", confirmText="Tak, usuń fakturę",
  message="Czy na pewno chcesz usunąć fakturę? Tej operacji nie będzie można cofnąć.",
  showDoNotAskAgainCheckbox=false,
  doNotAskAgainText="Nie pytaj o to ponownie." }) => {

  const [checked, setChecked] = React.useState(false);

  return (
    <Modal title={title} onClose={onClose} sx={{ width: 600 }}>
      <Styled.Message>
        {message}
      </Styled.Message>
      {showDoNotAskAgainCheckbox && <Checkbox sx={{mt:3}} checked={checked} onChange={(e) => setChecked(e)} label={doNotAskAgainText} />}
      <Styled.Actions>
        <Button onClick={(e) => onClose(e, checked)} variant="outlined">
          {cancelText}
        </Button>
        <Button onClick={(e) => onConfirm(e, checked)} loading={isSaving} color="error">
          {confirmText}
        </Button>
      </Styled.Actions>
    </Modal>
  );
};

DeleteListItemConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
